// Volto's addon machinery auto-imports each addon's default export and invokes it
// as `applyConfig(config)`. volto-typography does no JS-side configuration — it ships
// only theme/_main.scss for SCSS aggregation. The default export exists to satisfy
// Volto's structural requirement (per
// https://6.docs.plone.org/volto/conceptual-guides/add-ons.html — "the main key of
// their package.json must point to a module that exports a default function").
const applyConfig = (config) => config;
export default applyConfig;
